/* eslint-disable react/destructuring-assignment */
import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useGlobal } from '@rcg/ui-react';
import TextField from '../../components/TextField';
import useStyles from './index.style';
import { MAX_NUMBER_OF_GUESTS } from '../../commons';

export const Fields = (props) => {
  const {
    errors,
    handleChange,
    isValid,
    numberOfGuests,
    setFieldTouched,
    showEmailInput,
    touched,
    values,
  } = props;

  const classes = useStyles();
  const change = (name, e) => {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  };

  const submit = (event) => {
    event.preventDefault();
    const futureCruiseCredits = [...Array(parseInt(MAX_NUMBER_OF_GUESTS, 10)).keys()]
      .map((key) => props.values[`cruiseCredit_${key}`])
      .filter((node) => node !== '');
    const { emailAddress } = props.values;
    props.submit({
      variables: {
        codes: futureCruiseCredits,
        ...(emailAddress && { emailAddress }),
      },
    });
  };

  const cancel = (event) => {
    event.preventDefault();
    props.cancel();
  };

  const { renderContent } = useGlobal();

  const createCruiseCreditFields = () => {
    return [...Array(parseInt(numberOfGuests, 10)).keys()].map((key) => {
      const id = `cruiseCredit_${key}`;
      return (
        <Grid item xs={12} sm={6} key={`cruise_credit_key_${key}`}>
          <TextField
            inputProps={{ 'data-testid': `cruise-credit-${key}` }}
            error={touched[id] && Boolean(errors[id])}
            helperText={touched[id] ? errors[id] : ''}
            id={id}
            label={renderContent('formCruiseCreditFieldCerfiticate', 'Future Cruise Credit Code')}
            onChange={change.bind(null, id)}
            placeholder={renderContent(
              'formCruiseCreditCertificate',
              'Enter future cruise credit code',
            )}
            value={values[id]}
          />
        </Grid>
      );
    });
  };

  const emailField = () => {
    const id = 'emailAddress';
    return (
      <>
        <Grid item xs={12} className={classes.emailGrid}>
          <Typography className={`form__subTitle ${classes.emailCopy}`}>
            {renderContent(
              'formCruiseCreditEmailEntryLabel',
              'Please provide an email address so that we can update you on the status of your redemption.',
            )}
          </Typography>
        </Grid>

        <Grid container>
          <Grid item xs={12} sm={6}>
            <TextField
              data-testid={id}
              error={touched[id] && Boolean(errors[id])}
              helperText={touched[id] ? errors[id] : ''}
              id={id}
              label={renderContent('formBookingAmendFieldEmailLabel', 'Email Address')}
              name={id}
              onChange={change.bind(null, id)}
              placeholder={renderContent('formCruiseCreditFieldEmail', 'Enter an email address')}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <form onSubmit={submit.bind(this)} className={classes.root}>
      <Grid container mt={3} className={classes.gridContainer}>
        {createCruiseCreditFields()}
        {showEmailInput && emailField()}
        <Grid xs={12} item classes={{ root: classes.fccActions }}>
          <Button
            data-testid="credit-cancel"
            className={classes.fccButtonCancel}
            color="primary"
            type="button"
            variant="outlined"
            onClick={cancel}>
            {renderContent('formCruiseCreditButtonCancel', 'cancel')}
          </Button>
          <Button
            data-testid="credit-submit"
            className={classes.fccButtonSubmit}
            color="primary"
            disabled={!isValid}
            type="submit"
            variant="contained">
            {renderContent('formCruiseCreditButtonSubmit', 'submit')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Fields;
